import '../auth.css';
import './signup.css';
import { useState } from 'react';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { Link, useNavigate } from 'react-router-dom';
import { auth } from '../../../firebase/firebase';
import { ImageGame } from '../../../assets';
import { onBlur, validatePassword, ValidationState } from '../auth.props';
import {
  FeedbackMessage,
  GoogleAuthButton,
  LineDivider,
  Spin,
} from '../../../components';
import { ROUTES } from '../../../routes';

const SignUp = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState<boolean>(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState<ValidationState>({});

  const passwordErrors = validatePassword(password);

  const allOk =
    (email.length > 0 &&
      password.length > 0 &&
      !errors.email &&
      !errors.password &&
      passwordErrors.length === 0) ||
    loading;

  const createUserProfile = async (uid: string, emailValue: string) => {
    const response = await fetch(
      'https://europe-west3-imperialstonesgame.cloudfunctions.net/createUserProfile',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          uid,
          email: emailValue,
        }),
      },
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data?.error || 'No se pudo crear perfil');
    }

    return data;
  };

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault();

    setLoading(true);

    try {
      const res = await createUserWithEmailAndPassword(auth, email, password);

      await createUserProfile(res.user.uid, res.user.email || email);

      navigate(ROUTES.COMPLETE_PROFILE);
    } catch (error) {
      setErrors((prev) => ({
        ...prev,
        password: 'Ocurrió un error, inténtalo más tarde',
      }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="isg-auth-page">
      <img
        src={ImageGame}
        alt="Imperial Stones Game"
        className="isg-auth-image-bg"
      />

      <div className="isg-auth-form-container">
        <h1>REGISTRARSE</h1>

        <form className="isg-auth-form-box" onSubmit={handleRegister}>
          <input
            className="isg-input"
            type="email"
            value={email}
            placeholder="Email"
            onChange={(e) => setEmail(e.target.value)}
            onBlur={(e) => onBlur(e.target.value, 'email', setErrors)}
            required
          />

          {errors.email?.length ? (
            <FeedbackMessage message={errors.email} />
          ) : null}

          <input
            className="isg-input"
            type="password"
            value={password}
            placeholder="Contraseña"
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <div className="isg-create-password-box">
            <FeedbackMessage
              message="8 caracteres"
              type={passwordErrors.includes('length') ? 'info' : 'success'}
            />

            <FeedbackMessage
              message="Un número"
              type={passwordErrors.includes('number') ? 'info' : 'success'}
            />

            <FeedbackMessage
              message="Una mayúscula"
              type={passwordErrors.includes('uppercase') ? 'info' : 'success'}
            />

            <FeedbackMessage
              message="Una minúscula"
              type={passwordErrors.includes('lowercase') ? 'info' : 'success'}
            />

            <FeedbackMessage
              message="Caracter especial"
              type={passwordErrors.includes('character') ? 'info' : 'success'}
            />
          </div>

          <button
            className={`isg-form-button ${!allOk ? 'disabled' : ''}`}
            type="submit"
            disabled={!allOk}
          >
            <Spin spin={loading} size={20} className="isg-spin-floating" />

            <p className={loading ? 'loading' : ''}>Registrarse</p>
          </button>

          <LineDivider />

          <GoogleAuthButton />

          <p className="isg-auth-sininup-link">
            ¿Ya tienes una cuenta?{' '}
            <Link to={ROUTES.SIGNIN} target="_top">
              Iniciar sesión
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default SignUp;
